import { CallEffect, takeEvery, call } from 'redux-saga/effects';

import getProjectFromPathname from 'js/sagas/sagaHelpers/getProjectFromPathname';
import { ExistingScribeModel } from 'js/types';
import { setEditingScript, startNewScript } from 'js/reducers/projectScripts';
import { startFromScript } from 'js/reducers/voiceoversReducer';

import { track } from '../mixpanelProvider';

function* trackScriptEvent(eventName: string): Generator<CallEffect, void, ExistingScribeModel | undefined> {
  const project = yield call(getProjectFromPathname);
  const eventProperties = project ? { 'Scribe ID': project.id } : undefined;

  yield call(track, eventName, eventProperties);
}

const trackStartNewScript = () => trackScriptEvent('Clicked New Script Button');
const trackEditingScript = () => trackScriptEvent('Clicked Script In This Project Section');
const trackStartNewScriptFromVoiceover = () => trackScriptEvent('Clicked Generate Voiceover From Script');

export default function* trackProjectScriptsSagas() {
  yield takeEvery(startNewScript.type, trackStartNewScript);
  yield takeEvery(setEditingScript.type, trackEditingScript);
  yield takeEvery(startFromScript.type, trackStartNewScriptFromVoiceover);
}
